import React, { useState } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "react-phone-input-2/lib/style.css"
import { useSelector } from "react-redux"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  CardText,
  FormGroup,
} from "reactstrap"

const ChangeSecurityPin = () => {
  const [form, setForm] = useState({
    securityPin: "",
    newSecurityPin: "",
    confirmSecurityPin: "",
  })

  const [passwordType, setPasswordType] = useState("password")
  const [passwordType1, setPasswordType1] = useState("password")
  const [passwordType12, setPasswordType12] = useState("password")

  const { error, success } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
  }))

  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const token = authUser?.token

  const handleChange = e => {
    const { name, value } = e.target

    // Allow only numbers and limit to 4 digits
    const numericValue = value.replace(/\D/g, "").slice(0, 4)

    setForm(prev => ({
      ...prev,
      [name]: numericValue,
    }))
  }

  const validateForm = () => {
    if (!form.securityPin || !form.newSecurityPin || !form.confirmSecurityPin) {
      toast.error("All fields are required")
      return false
    }
    if (form.securityPin.length !== 4) {
      toast.error("Current pin must be exactly 4 digits")
      return false
    }
    if (form.newSecurityPin.length !== 4) {
      toast.error("New pin must be exactly 4 digits")
      return false
    }
    if (form.newSecurityPin !== form.confirmSecurityPin) {
      toast.error("New pin and confirm pin don't match")
      return false
    }
    if (form.securityPin === form.newSecurityPin) {
      toast.error("New pin must be different from current pin")
      return false
    }
    return true
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) return

    try {
      const data = {
        securityPin: form.securityPin,
        newSecurityPin: form.newSecurityPin,
        confirmSecurityPin: form.confirmSecurityPin,
      }

      const response = await axios.post(URLS.ChangePin, data, {
        headers: { Authorization: `Bearer ${token}` },
      })

      if (response.status === 200) {
        toast.success(response.data.message)
        setForm({
          securityPin: "",
          newSecurityPin: "",
          confirmSecurityPin: "",
        })
      }
    } catch (error) {
      if (error.response) {
        toast.error(
          error.response.data.message || "Failed to Change Security Pin"
        )
      } else {
        toast.error("Network error. Please try again.")
      }
    }
  }

  const togglePassword = () => {
    setPasswordType(prev => (prev === "password" ? "text" : "password"))
  }

  const togglePassword1 = () => {
    setPasswordType1(prev => (prev === "password" ? "text" : "password"))
  }

  const togglePassword12 = () => {
    setPasswordType12(prev => (prev === "password" ? "text" : "password"))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Bizzmate Supplier"
            breadcrumbItem="Change Security Pin"
          />
          <Row className="d-flex justify-content-center">
            <Col lg="6">
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="primary">{success}</Alert>}
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <CardText>
                      <Row className="mt-3">
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label>
                              Current Pin
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                              <input
                                name="securityPin"
                                placeholder="Enter 4-digit pin"
                                className="form-control"
                                required
                                type={passwordType}
                                value={form.securityPin}
                                onChange={handleChange}
                                pattern="\d{4}"
                                title="Please enter exactly 4 digits"
                                inputMode="numeric"
                                maxLength="4"
                              />
                              <div className="input-group-btn">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={togglePassword}
                                >
                                  {passwordType === "password" ? (
                                    <i
                                      className="fa fa-eye-slash"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-eye"
                                      aria-hidden="true"
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label>
                              New Pin
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                              <input
                                name="newSecurityPin"
                                placeholder="Enter 4-digit pin"
                                required
                                type={passwordType1}
                                className="form-control"
                                value={form.newSecurityPin}
                                onChange={handleChange}
                                pattern="\d{4}"
                                title="Please enter exactly 4 digits"
                                inputMode="numeric"
                                maxLength="4"
                              />
                              <div className="input-group-btn">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={togglePassword1}
                                >
                                  {passwordType1 === "password" ? (
                                    <i
                                      className="fa fa-eye-slash"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-eye"
                                      aria-hidden="true"
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label>
                              Confirm Pin
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                              <input
                                name="confirmSecurityPin"
                                placeholder="Enter 4-digit pin"
                                required
                                type={passwordType12}
                                className="form-control"
                                value={form.confirmSecurityPin}
                                onChange={handleChange}
                                pattern="\d{4}"
                                title="Please enter exactly 4 digits"
                                inputMode="numeric"
                                maxLength="4"
                              />
                              <div className="input-group-btn">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={togglePassword12}
                                >
                                  {passwordType12 === "password" ? (
                                    <i
                                      className="fa fa-eye-slash"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-eye"
                                      aria-hidden="true"
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardText>
                    <div style={{ float: "right" }}>
                      <Button type="submit" color="primary" className="btn-sm">
                        Submit
                      </Button>
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer position="top-right" autoClose={5000} />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ChangeSecurityPin
